import React, { useEffect, useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
  customStyle
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from 'moment';
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const WaiteReport = () => {
  const { t } = useTranslation();
  //getting context values here
  let { loading, dataPaginating, setDataPaginating, generalSettings } = useContext(SettingsContext);
  const { authUserInfo, waiterForSearch } = useContext(UserContext);
  const { branchForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const [reportSummaryData, setReportSummaryData] = useState(null);

  const componentRef = useRef();
  const componentRef1 = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);

  const [siteName, setSiteName] = useState("");
  const [waiter, setWaiter] = useState(null);
  const [branch, setBranch] = useState(null);
  const [reportOption, setReportOption] = useState("detail");

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
  }, [generalSettings]);

  const handleWaiter = (waiter) => {
    setWaiter(waiter)
  }

  const handleReportOption = (e) => {
    setReportOption(e.target.value)
  }

  const handleBranch = (branches) => {
    setBranch(branches);
  }

  //get BranchWise reports filter
  const getwaiterWiseSelected = () => {
    setReportData(null);
    setReportSummaryData(null);
    if ((authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") && !branch?.[0]?.id) {
      toast.error(`${_t(t("Please select branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    if (
      startDate !== null &&
      endDate !== null
    ) {
      setDataPaginating(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate = moment(endDate).format("YYYY-MM-DD");
      const branh = (branch && branch?.length) ? branch.map((item) => item.id) : "";

      const url = BASE_URL + "/settings/get-waiter-orders-reports";
      let formData = {
        from_date: fromDate,
        to_date: toDate,
        waiter_id: waiter?.id ? waiter?.id : "",
        branch_id: branh,
        type: reportOption
      }

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {

          setGeneratedReport(true);
          if (reportOption === "detail") {
            setReportData(res.data);
            componentRef.current.handleDownload();
          } else {
            setReportSummaryData(res.data);
            componentRef1.current.handleDownload();
          }
          setDataPaginating(false);
          setBranch(null);
          setWaiter(null);
        })
        .catch((error) => {
          setDataPaginating(false);
          if (error.response?.data?.status === 0) {
            toast.error(
              `${_t(t(error.response.data?.message))}`,
              {
                position: "bottom-center",
                closeButton: false,
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
              }
            );
            return;
          }
        });
    } else {
      toast.error(
        `${_t(t("Please select from date, to date"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  let g_total = 0;
  let g_Amount = 0;
  let g_tax = 0;

  let g_totalOrders = 0;
  let g_summaryDiscount = 0;
  let g_summarySubtotal = 0;
  let g_summaryTax = 0;
  let g_summaryTotal = 0;
  let g_serviceCharge = 0;
  
  return (
    <>
      <Helmet>
        <title>{_t(t("Waiter Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls1"
        filename="Waiter Report"
        sheet="sheet 1"
        buttonText="waiter Detail"
        ref={componentRef}
      />

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Waiter Report"
        sheet="sheet 1"
        buttonText="waiter Detail"
        ref={componentRef1}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls1"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="15" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Waiter Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >{_t(t("Branch"))}</th>
                                  {/* <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Waiter"))}
                                  </th> */}
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Date"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Order No"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Order Type"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Party Type"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Customer"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Waiter Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Subtotal"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Tax"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Discount"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("D.Charges"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("S.Charges"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Payment Type"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Net Amount"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {Object.keys(reportData).map(
                                  (group_name, index) => {
                                    let b_total = 0;
                                    let b_amount = 0;
                                    let b_tax = 0;
                                    return (
                                      <>
                                        <tr key={index}>
                                          <th
                                            scope="row"
                                          >
                                            {group_name}
                                          </th>
                                        </tr>
                                        {reportData[group_name] && Object.keys(reportData[group_name])?.map(
                                          (waiter) => {
                                            let total = 0;
                                            let Amount = 0;
                                            let tax = 0;
                                            return (
                                              <>
                                                {/* <tr>
                                                  <td></td>
                                                  <td>{waiter}</td> 
                                                </tr>   */}
                                                {reportData[group_name][waiter] &&
                                                  reportData[group_name][waiter].map((item, i) => {
                                                    total += parseFloat(item.total_payable);
                                                    Amount += parseFloat(item.order_bill);
                                                    tax += parseFloat(item.vat);
                                                    b_total += parseFloat(item.total_payable);
                                                    b_amount += parseFloat(item.order_bill);
                                                    b_tax += parseFloat(item.vat);
                                                    g_total += parseFloat(item.total_payable);
                                                    g_Amount += parseFloat(item.order_bill);
                                                    g_tax += parseFloat(item.vat);

                                                    return (
                                                      <tr key={i}>
                                                        <td></td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {i + 1}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          <Moment format="LL">
                                                            {item.order_date}
                                                          </Moment>
                                                        </td>
                                                        <td>
                                                          {item.order_no}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.order_type_name}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.party_name}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.customer_name}
                                                        </td>
                                                        <td>{waiter}</td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.order_bill}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.vat}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.discount_amount}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.delivery_charges}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.service_charges}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.payment_type}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                        >
                                                          {item.total_payable}
                                                        </td>
                                                      </tr>
                                                    );
                                                  })
                                                }
                                                <tr>
                                                  <th colspan="7"></th>
                                                  <th>{waiter}</th>
                                                  <td>
                                                    <strong>{formatPrice(Amount)}</strong>
                                                  </td>
                                                  <td>
                                                    <strong>{formatPrice(tax)}</strong>
                                                  </td>
                                                  <td>
                                                  </td>
                                                  <td>
                                                  </td>
                                                  <td>
                                                  </td>
                                                  <td>
                                                  </td>
                                                  <td>
                                                    <strong>{formatPrice(total)}</strong>
                                                  </td>
                                                </tr>
                                                <tr></tr>
                                              </>
                                            );
                                          }
                                        )}
                                        <tr>
                                          <th colspan="7"></th>
                                          <th>
                                            Branch Total
                                          </th>
                                          <td>
                                            <strong>{formatPrice(b_amount)}</strong>
                                          </td>
                                          <td>
                                            <strong>{formatPrice(b_tax)}</strong>
                                          </td>
                                          <td>
                                          </td>
                                          <td>
                                          </td>
                                          <td>
                                          </td>
                                          <td>
                                          </td>
                                          <td>
                                            <strong>{formatPrice(b_total)}</strong>
                                          </td>
                                        </tr>
                                        <tr></tr>
                                      </>
                                    );
                                  }
                                )}
                                <tr>
                                  <th colspan="7"></th>
                                  <th>
                                    Grand Total
                                  </th>
                                  <td>
                                    <strong>{formatPrice(g_Amount)}</strong>
                                  </td>
                                  <td>
                                    <strong>{formatPrice(g_tax)}</strong>
                                  </td>
                                  <td>
                                  </td>
                                  <td>
                                  </td>
                                  <td>
                                  </td>
                                  <td>
                                  </td>
                                  <td>
                                    <strong>{formatPrice(g_total)}</strong>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="10"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportSummaryData !== null &&
                    reportSummaryData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="9" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Waiter Summary Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >{_t(t("Branch"))}</th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("S/L"))}
                                  </th>

                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Waiter Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Total Orders"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Sub Total"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Tax"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Service Charges"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Discount Amount"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Net Amount"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {
                                  reportSummaryData && Object.keys(reportSummaryData).map((group) => {
                                    let total = 0;
                                    return (
                                      <>
                                        <tr>
                                          <th>
                                            {group}
                                          </th>
                                        </tr>
                                        {reportSummaryData[group] && reportSummaryData[group]?.map(
                                          (item,i) => {
                                            g_totalOrders += Number(item.total_orders);
                                            g_summaryDiscount += Number(item.discount_amount);
                                            g_summarySubtotal += Number(item.order_bill);
                                            g_summaryTax += Number(item.vat);
                                            g_summaryTotal += Number(item.total_payable);
                                            g_serviceCharge += Number(item.service_charge);
                                            total += Number(item.total_payable);
                                            return (
                                              <>
                                                <tr key={i}>
                                                  <td></td>
                                                  <td>
                                                    {i + 1}
                                                  </td>
                                                  <td>{item.waiter_name}</td>
                                                  <td>{item.total_orders}</td>
                                                  <td>
                                                    {item.order_bill}
                                                  </td>
                                                  <td>
                                                    {item.vat}
                                                  </td>
                                                  <td>
                                                    {item.service_charge}
                                                  </td>
                                                  <td>
                                                    {item.discount_amount}
                                                  </td>
                                                  <td>
                                                    {item.total_payable}
                                                  </td>
                                                </tr>
                                              </>
                                            );
                                          }
                                        )}

                                        <tr>
                                          <th colspan="5"></th>
                                          <th colSpan={3}>
                                            Total
                                          </th>
                                          <td>
                                            <strong>{formatPrice(total)}</strong>
                                          </td>
                                        </tr>
                                        <tr></tr>
                                      </>
                                    )
                                  })
                                }

                                <tr>
                                  <th colspan="2"></th>
                                  <th>
                                    Grand Total
                                  </th>
                                  <td>
                                    <strong>{formatPrice(g_totalOrders)}</strong>
                                  </td>
                                  <td>
                                    <strong>{formatPrice(g_summarySubtotal)}</strong>
                                  </td>
                                  <td>
                                    <strong>{formatPrice(g_summaryTax)}</strong>
                                  </td>
                                  <td>
                                    <strong>{formatPrice(g_serviceCharge)}</strong>
                                  </td>
                                  <td>
                                    <strong>{formatPrice(g_summaryDiscount)}</strong>
                                  </td>
                                  <td>
                                    <strong>{formatPrice(g_summaryTotal)}</strong>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="6"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={dataPaginating || loading} />

                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-12 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Waiter Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row gx-2 mt-2">
                        <div className="col-2">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2 t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>
                        <div className="col-md-2 t-mb-15 mb-md-0">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control sm-text py-2"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0">
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            classNamePrefix="select"
                            className="sm-text"
                            isMulti
                            value={branch || ""}
                            styles={customStyle}
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                            isClearable
                          />
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0">
                          <Select
                            options={waiterForSearch ? waiterForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            classNamePrefix="select"
                            className="sm-text "
                            value={waiter || ""}
                            styles={customStyle}
                            onChange={handleWaiter}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a waiter")) + ".."}
                            isClearable
                          />
                        </div>

                        <div className="col-2">
                          <div style={{ marginTop: "-0.8rem" }} className="d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="detail"
                              name="detail"
                              value="detail"
                              onChange={(e) => {
                                handleReportOption(e);
                              }}
                              checked={
                                reportOption === "detail"
                              }
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1"
                              htmlFor="detail"
                            >
                              {_t(t("Detail Report"))}
                            </label>
                          </div>
                          <div className="mt-1 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="summary"
                              name="summary"
                              value="summary"
                              onChange={(e) => {
                                handleReportOption(e);
                              }}
                              checked={
                                reportOption === "summary"
                              }
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1"
                              htmlFor="summary"
                            >
                              {_t(t("Summary Report"))}
                            </label>
                          </div>
                        </div>
                        <div className="col-2">
                          <button
                            className="float-right btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                            onClick={(e) => getwaiterWiseSelected(e)}
                          >
                            Waiter Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>

    </>
  );
};

export default WaiteReport;
